/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TripleChevronSvg from './icon-triple-chevron.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TripleChevronSvg {...validProps} />;
}
SvgComponent.iconName = 'tripleChevron';

export const TripleChevronIcon = svgIconWrapper(SvgComponent);
